<template>
  <li
    :class="{'-active': isActive}"
    class="sidebar-item-child"
  >
    <a
      :href="href"
      @click="navigate"
      class="link"
      v-bind="$attrs"
    >
      <slot></slot>
    </a>
  </li>
</template>

<script>
export default {
  name: 'SidebarItemChild',

  props: {
    href: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    /**
     * Navigate the url
     *
     * @param e
     */
    navigate(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  .sidebar-item-child {
    > .link {
      padding: 7px 25px;
      font-size: .75rem;
      color: theme('colors.secondary.700');
      display: block;
      position: relative;
      letter-spacing: 0.06em;
      font-weight: 500;
      outline: none;

      &:after {
        position: absolute;
        content: "";
        top: 37%;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: #fff;
        border: 2px solid #595c60;
        left: 5.5px;
      }
    }

    &.-active,
    &:hover {
      > .link {
        color: theme('colors.primary.500');
        border-left-color: theme('colors.primary.500');
      }
    }
  }
</style>
